import { i18n } from "@/shared/lib/i18n";
import { useLanguageStore } from "@/shared/lib/store/app-store";
import { DotsLoader } from "@/shared/ui/spinner";
import { Text } from "@/shared/ui/typography";

export function ChartSkeleton({ height = 300 }: { height?: number }) {
	return (
		<div
			aria-hidden="true"
			className="animate-pulse rounded-lg border border-border/60 bg-muted/30"
			style={{ height }}
		/>
	);
}

export function CardSkeleton({ height = 200 }: { height?: number }) {
	return (
		<div
			aria-hidden="true"
			className="animate-pulse rounded-lg border border-border/60 bg-muted/20 p-4"
			style={{ height }}
		>
			<div className="mb-3 h-4 w-1/3 rounded bg-muted/50" />
			<div className="h-3 w-2/3 rounded bg-muted/40" />
		</div>
	);
}

export function EditorSkeleton() {
	const isLocalized = useLanguageStore((state) => state.locale !== "en");
	return (
		<div
			aria-hidden="true"
			className="flex h-full min-h-[400px] items-center justify-center bg-muted/10"
		>
			<div className="flex flex-col items-center gap-2">
				<DotsLoader className="text-primary" size="lg" />
				<Text as="span" tone="muted" variant="caption">
					{i18n.getMessage("aria_loading_editor", isLocalized)}\u2026
				</Text>
			</div>
		</div>
	);
}
